<template>
  <section>
    <Header :user="user" />
    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <div class="contenedor py-0">
        <div class="row px-0 py-0">
          <div class="col-12 px-2 py-0">
            <Infrastructure @udpdateHeader="udpdateHeader" />
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import Infrastructure from "@/components/Infrastructure/Infrastructure.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "AllInfrastructure",
  components: {
    Infrastructure,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route, child = "") {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: child });
    },
  },
};
</script>
